import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/core/modules/shared.module';
import { LoginComponent } from './login/login.component';
import { LoginRouting } from './login.routing';
import { AppPipesModule } from '../core/pipes/pipes.module';
import { TranslateApplicationService } from '../core/translate/translate-application-service';
import { ApplicationInfoService } from '../core/translate/application-info.service';
import { TranslateService } from '../core/services/translate-service';

@NgModule({
  declarations: [
    LoginComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    LoginRouting,
    AppPipesModule,
  ],
  providers: [
  ]
})
export class LoginModule { }
